module.exports = __webpack_public_path__ + "static/img/manual-25.ddd16da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-25.png
// module id = k9bY
// module chunks = 4